import List from "./List";
import DonutSmall from "@material-ui/icons/DonutSmall";

export const StockList = List;
export const StockIcon = DonutSmall;
